import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=1005e6aa&scoped=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=1005e6aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1005e6aa",
  null
  
)

export default component.exports